import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue";
var _hoisted_1 = {
  style: {
    "margin": "12px 50px"
  }
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  key: 1
};
import LoadingSlot from './loading.vue';
import Pagination from '@/components/pagination.vue';
import * as Icons from '@element-plus/icons-vue';
export default /*#__PURE__*/_defineComponent({
  props: ['tableBody', 'tableHeader', 'options', 'params'],
  emits: ['handleSelect', 'onChangePage', 'onEdit'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;

    var handleSelect = function handleSelect(selection) {
      emits('handleSelect', selection);
    };

    var getIcon = function getIcon(name) {
      return Icons[name];
    };

    return function (_ctx, _cache) {
      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_edit_pen = _resolveComponent("edit-pen");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_table = _resolveComponent("el-table");

      return _openBlock(), _createBlock(LoadingSlot, {
        loading: __props.options.loading
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_table, {
            style: {
              "width": "100%"
            },
            data: __props.tableBody,
            onSelectAll: handleSelect,
            onSelect: handleSelect
          }, {
            default: _withCtx(function () {
              return [__props.options.selection ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "50"
              })) : _createCommentVNode("", true), !__props.options.noExpand ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                type: "expand"
              }, {
                default: _withCtx(function (scope) {
                  return [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableHeader, function (item1, idx) {
                    return _openBlock(), _createElementBlock(_Fragment, null, [!item1.hideB ? (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "mb10 fl",
                      style: _normalizeStyle('padding-right:10; box-sizing: border-box; width: ' + (item1['expandWidth'] || '50%'))
                    }, [_createElementVNode("span", null, _toDisplayString(item1.title) + "：", 1), _createElementVNode("span", null, _toDisplayString(scope.row[item1.key]), 1)], 4)) : _createCommentVNode("", true)], 64);
                  }), 256))])];
                }),
                _: 1
              })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableHeader, function (item, index) {
                return _openBlock(), _createElementBlock(_Fragment, null, [!item.hideH ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: index,
                  label: item.title,
                  sortable: item.sortable,
                  width: item.width,
                  "min-width": item.minWidth
                }, {
                  default: _withCtx(function (scope) {
                    return [item.editFlag && scope.row.applyStatus === 'APPROVING' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [scope.row.state === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_createTextVNode(_toDisplayString(scope.row[item.key]) + " ", 1), _createVNode(_component_el_icon, {
                      onClick: function onClick($event) {
                        return emits('onEdit', scope.row);
                      }
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_edit_pen)];
                      }),
                      _: 2
                    }, 1032, ["onClick"])])) : (_openBlock(), _createBlock(_component_el_select, {
                      key: 1,
                      modelValue: scope.row.modifyId,
                      "onUpdate:modelValue": function onUpdateModelValue($event) {
                        return scope.row.modifyId = $event;
                      },
                      size: "mini"
                    }, {
                      default: _withCtx(function () {
                        return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.modifyList, function (item) {
                          return _openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]);
                        }), 128))];
                      }),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [item.preIcon && scope.row[item.iconShowKey] === item.iconShowValue ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0,
                      class: _normalizeClass([item.preIcon, 'f16', 'blue'])
                    }, {
                      default: _withCtx(function () {
                        return [(_openBlock(), _createBlock(_resolveDynamicComponent(getIcon(item.preIcon))))];
                      }),
                      _: 2
                    }, 1032, ["class"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(scope.row[item.key]), 1)]))];
                  }),
                  _: 2
                }, 1032, ["label", "sortable", "width", "min-width"])) : _createCommentVNode("", true)], 64);
              }), 256)), _renderSlot(_ctx.$slots, "default")];
            }),
            _: 3
          }, 8, ["data"]), __props.options.pagination ? (_openBlock(), _createBlock(Pagination, {
            key: 0,
            options: __props.options,
            params: __props.params,
            onOnChange: _cache[0] || (_cache[0] = function ($event) {
              return emits('onChangePage', $event);
            })
          }, null, 8, ["options", "params"])) : _createCommentVNode("", true)];
        }),
        _: 3
      }, 8, ["loading"]);
    };
  }
});